/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { integrationCustomFieldMappingCreateRequestSchema } from './integrationCustomFieldMappingCreateRequestSchema';
import { integrationFieldMappingsSchema } from './integrationFieldMappingsSchema';

export const updateFieldMappingsRequestSchema = z.object({
  get customFieldMappings() {
    return z.array(integrationCustomFieldMappingCreateRequestSchema);
  },
  get standardFieldsMappings() {
    return integrationFieldMappingsSchema;
  },
});
